import React, { useState } from "react";
import logo_krezco from "../../static/images/logo-krezco.svg";
import { Empresa } from "./ImagenData";

const ManualEmpresa = () => {
  const [currentIndex, setCurrentIndex] = useState(0);

  const handleNext = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % Empresa.length);
  };

  const handlePrev = () => {
    setCurrentIndex((currentIndex - 1 + Empresa.length) % Empresa.length);
  };

  const handleRestart = () => {
    setCurrentIndex(0);
  };

  return (
    <div className="login">
      <div className="containerManual">
        <div className="row">
          <div className="col-sm-12 align-div--middle">
            <div className="login__content-wrapper">
              <img className="logo" src={logo_krezco} alt="Logo Krezco"></img>
              <div className="card--manual form--white form--bordered">
                <img
                  className="imgmanual"
                  src={Empresa[currentIndex]}
                  alt={`Empresa ${currentIndex + 1}`}
                ></img>
              </div>
            </div>
          </div>
        </div>
        <div className="row btnManual ">
          <div className="col-3">
            {currentIndex > 0 && (
              <button
                onClick={handlePrev}
                className="btn btn--gradient btnManual"
              >
                <i className="fas fa-long-arrow-left"></i> Anterior
              </button>
            )}
          </div>
          <div className="col-3">
            <button
              className="btn btn--gradient btnManual"
              onClick={handleNext}
            >
              Siguiente <i className="fas fa-long-arrow-right"></i>
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ManualEmpresa;
